// extracted by mini-css-extract-plugin
module.exports = {"brief":"Brief_brief__186-n","title":"Brief_title__3eMOV","subtitle":"Brief_subtitle__pc82C","video":"Brief_video__xgrnd","hidden":"Brief_hidden__gL8gj"};